import React from 'react'

export default function GameTags(props) {

  const classifity = props.game?.dynamic_label_classifity

  const getColor = (type) => {
    return type === 3 ? '#777' : '#888';
  }

  const getBackgroundColor = (type) => {
    return type == 3 ? '#F7F7F7' : 'transparent';
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', paddingTop: '2px' }}>
      {classifity.map((item, index) => {
        return (
          <>
            {
              item.type == 3 || item.type == 4 ?
                <div
                  style={{
                    color: getColor(item.type),
                    backgroundColor: getBackgroundColor(item.type),
                    borderRadius: item.type == 4 ? '0' : '3px',
                    padding: item.type == 4 ? 0 : '0px 5px',
                    marginRight: '5px',
                    borderRadius: item.type == 4 ? '0' : '3px',
                    fontSize: item.type == 4 ? '11px' : '10px',
                    height: '15px',
                    lineHeight: '1',
                    display: item.type == 3 ? 'flex' : 'inline-block',
                    alignItems: 'center',
                    flexShrink: item.type == 3 ? '0' : '1',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                  key={index}>{item.name}</div> :
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginRight: '5px',
                    backgroundColor: item.type == 1 ? '#FFF0EB' : '#FFF0F0',
                    borderRadius: '3px',
                    color: item.type == 1 ? '#F4692B' : '#FC2727',
                    flexShrink: '0'
                  }}>
                  {item.type == 1 ? <img src="resources/modifyprice/xianshi.png" alt="" height={15} /> : <img src="resources/modifyprice/jingpin.png" alt="" height={15} />}
                  <div style={{
                    fontSize: '10px',
                    padding: '0 5px 0 3px',
                    height: '15px',
                    flexShrink: '0'
                  }}>{item.name}</div>
                </div>
            }
          </>
        )
      })}
    </div>
  )
}
